/**
 * tasks.ts — Tareas por defecto para el modo demo.
 */
import type { Tarea } from "@/features/personal/types/task";

const now = new Date();
const tomorrow = new Date(now.getTime() + 24 * 60 * 60 * 1000).toISOString();
const nextWeek = new Date(
  now.getTime() + 7 * 24 * 60 * 60 * 1000,
).toISOString();

export const defaultTasks: Tarea[] = [
  {
    id: "task_1",
    titulo: "Limpieza de mostradores",
    descripcion:
      "Limpiar y desinfectar todos los mostradores de atención al cliente.",
    asignadoA: ["todos"],
    estado: "pendiente",
    prioridad: "alta",
    categoria: "Limpieza",
    fechaLimite: tomorrow,
    orden: 1,
    esRecurrente: true,
    horaReset: "06:00",
    tiempoEstimado: 20,
    historial: [],
    createdAt: now.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: "task_2",
    titulo: "Revisión de inventario crítico",
    descripcion: "Verificar existencias de los 10 productos más vendidos.",
    asignadoA: ["emp_1", "emp_2"],
    estado: "en_progreso",
    prioridad: "media",
    categoria: "Inventario",
    fechaLimite: tomorrow,
    orden: 2,
    tiempoEstimado: 45,
    iniciadaEn: new Date(now.getTime() - 3600000).toISOString(),
    historial: [],
    createdAt: now.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: "task_3",
    titulo: "Organizar bodega sección A",
    descripcion: "Acomodar las cajas nuevas recibidas en la mañana.",
    asignadoA: ["emp_3"], // Carlos Ruiz
    estado: "pendiente",
    prioridad: "baja",
    categoria: "Logística",
    fechaLimite: nextWeek,
    orden: 3,
    tiempoEstimado: 60,
    historial: [],
    createdAt: now.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: "task_4",
    titulo: "Cierre de caja matutino",
    descripcion: "Hacer el cuadre parcial de seguridad.",
    asignadoA: ["cajero"],
    estado: "completada",
    prioridad: "alta",
    categoria: "Finanzas",
    fechaLimite: now.toISOString(),
    orden: 0,
    completadaEn: new Date(now.getTime() - 7200000).toISOString(),
    completadoPorId: "emp_4",
    completadoPorNombre: "Sofia",
    duracionReal: 15,
    historial: [],
    createdAt: now.toISOString(),
    updatedAt: now.toISOString(),
  },
];
